import { useCallback } from 'react';
import {
  useCart,
  CartVersion,
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName,
  UpdateCartMutation,
  CartError
} from '../../hooks/useCart';
import { useCountry } from '../CountrySelector';

const getInvalidCodeMessageFromCartError = (error?: CartError | null) =>
  error?.type.name === 'Invalid Coupon' ? error.message : null;

export const getInvalidCodeMessage = (data?: UpdateCartMutation | null) =>
  getInvalidCodeMessageFromCartError(data?.updateCart.data[0].attributes.error);

export const useGiftCode = () => {
  const { cart } = useCart();
  const { country } = useCountry();
  const [updateCart, { data, error, loading }] = useUpdateCartMutation();

  const applyGiftCode = useCallback(
    (giftCode: string | null) =>
      updateCart(CartUpdateAction.Gift, {
        [CartUpdatePropertyName.Gift]: giftCode,
        [CartUpdatePropertyName.CountryCode]: country.alpha2Code
      }),
    [country.alpha2Code, updateCart]
  );

  return {
    giftCode: cart.attributes.version === CartVersion.MiniBag ? null : cart.attributes.giftCode,
    invalidCodeMessage:
      getInvalidCodeMessage(data) || getInvalidCodeMessageFromCartError(cart.attributes.error),
    error,
    loading,
    applyGiftCode
  };
};
